module.exports = {};


/*****************
 ** WEBPACK FOOTER
 ** ./src/core/routes.js
 ** module id = 40
 ** module chunks = 0
 **/